<!--<span>-->
<!--    <app-sfl-selector-->
<!--        type="Font"-->
<!--        [selected-item]="this.currentLocalFontToTriggerChanges"-->
<!--        [all-items]="localFonts"-->
<!--        [minimized]="false"-->
<!--        icon="font_download"-->
<!--        (onItemSelected)="newFontSelected($event)"></app-sfl-selector>-->
<button
    mat-icon-button
    [matMenuTriggerFor]="fontMenu"
    #fontMenuTrigger="matMenuTrigger"
    aria-label="Font Menu"
    *ngIf="iconMode">
    <mat-icon>font_download</mat-icon>
</button>
<button
    mat-button
    [matMenuTriggerFor]="fontMenu"
    #fontMenuTrigger="matMenuTrigger"
    aria-label="Font Menu"
    *ngIf="!iconMode"
    class="full-menu-button">
    <ng-container *ngIf="currentFont?.whiteThumbSrc; else fallbackText">
        <div
            class="font-thumb extenal"
            [style.background-image]="'url(' + baseCdnPath + currentFont.whiteThumbSrc + ')'"
            [attr.aria-label]="currentFont.name"
            role="img"></div>
    </ng-container>
    <ng-template #fallbackText>
        <mat-icon>font_download</mat-icon>
        Choose font
    </ng-template>
</button>

<mat-menu #fontMenu="matMenu" (click)="$event.stopPropagation()" class="fonts-menu">
    <mat-accordion class="font-accordion" *ngIf="currentFont" (click)="$event.stopPropagation()" xPosition="before">
        <div class="available-font" *ngFor="let font of localFonts">
            <mat-accordion>
                <mat-expansion-panel
                    [togglePosition]="'before'"
                    #fontPanel
                    [hideToggle]="!toDisplayWeightPick"
                    [expanded]="false"
                    (opened)="onAttemptExpand(fontPanel)">
                    <mat-expansion-panel-header
                        class="font-header clickable"
                        [class.active]="font.id === currentFont.id"
                        [class.disabled-click]="font.id === currentFont.id && !toDisplayWeightPick"
                        (click)="onFontHeaderClick(font, $event)">
                        <mat-panel-title>
                            <ng-container *ngIf="loadingFontId !== font.id; else loader">
                                <div
                                    class="font-thumb"
                                    [style.background-image]="'url(' + baseCdnPath + font.whiteThumbSrc + ')'"
                                    [attr.aria-label]="font.name"
                                    role="img"></div>
                            </ng-container>
                            <ng-template #loader>
                                <div class="uploader-status row-centered gapped">
                                    <mat-progress-spinner
                                        strokeWidth="4"
                                        class="loader-icon white-spinner"
                                        color="white"
                                        mode="indeterminate"
                                        diameter="25">
                                    </mat-progress-spinner>
                                </div>
                            </ng-template>
                        </mat-panel-title>
                    </mat-expansion-panel-header>

                    <div
                        class="font-style clickable"
                        [class.active]="style.id === currentFont.style && font.id === currentFont.id"
                        [class.disabled-click]="style.id === currentFont.style && font.id === currentFont.id"
                        *ngFor="let style of font.optionalStyles"
                        (click)="newStyleSelected(font, style)">
                        <div
                            class="font-thumb"
                            [style.background-image]="'url(' + baseCdnPath + style.whiteThumbSrc + ')'"
                            [attr.aria-label]="style"></div>
                    </div>
                </mat-expansion-panel>
            </mat-accordion>
        </div>
    </mat-accordion>
</mat-menu>

<!--    <app-sfl-selector-->
<!--        *ngIf="toDisplayWeightPick"-->
<!--        type="Font Style"-->
<!--        [selected-item]="this.currentStyle"-->
<!--        [all-items]="localFontStyles"-->
<!--        [minimized]="false"-->
<!--        icon="font_download"-->
<!--        (onItemSelected)="newStyleSelected($event)"></app-sfl-selector>-->

<!--    <mat-button-toggle-group-->
<!--        [value]="selectedWeight"-->
<!--        (change)="onWeightChange($event.value)"-->
<!--        appearance="legacy"-->
<!--        class="weight-toggle-group">-->
<!--        <mat-button-toggle *ngFor="let style of localFontStyles" [value]="style.value">-->
<!--            {{ style.name }}-->
<!--        </mat-button-toggle>-->
<!--    </mat-button-toggle-group>-->
<!--</span>-->
